<template>
  <a-layout-content id="testimonials" class="all-c testimonial-container">
    <h2 class="testimonial-title">{{ $t('whatOurCustomersAreSayingAboutUs') }}</h2>
    <div class=" testimonial-box">
      <div class="carousel">
        <a-carousel ref="carousel" :dots="false">
          <div class="testimonial" v-for="(testimonial, index) in testimonialsData" :key="index"
            :class="{ active: currentIndex === index }">
            <p class="scrollable">{{ testimonial.text }}</p>
            <div class="author">{{ testimonial.author }}</div>
          </div>
        </a-carousel>
      </div>
      <div class="team-bg">
        <img class="bg-img" src="../../public/8.png" alt="">
      </div>
    </div>
    <div class="testimonial-dots">
      <div class="testimonial-dot" v-for="(testimonial, index) in testimonialsData" :key="index"
        :class="{ active: currentIndex === index }" @click="showTestimonial(index)"></div>
    </div>
    <!--    <div class="carousel">
      <div class="carousel-content">
        <div
            class="testimonial"
            v-for="(testimonial, index) in testimonialsData"
            :key="index"
            :class="{ active: currentIndex === index }"
        >
          <p>{{ testimonial.text }}</p>
          <div class="author">{{ testimonial.author }}</div>
        </div>
      </div>
      <a-button
          class="left"
          icon="left"
          @click="prevTestimonial"
      ></a-button>
      <a-button
          class="right"
          icon="right"
          @click="nextTestimonial"
      ></a-button>
    </div>-->
  </a-layout-content>
</template>

<script>
export default {
  data() {
    return {
      customDotsClass: 'custom-dots', // 数据属性用于绑定dotsClass
      testimonialsData: [
        {
          text: "By the time we met Charlotte, we had seen countless specialists. However, Charlotte’s approach stood out as one of the kindest, most empathetic, realistic, and child-focused experiences we’d encountered. From the very beginning, I felt seen and heard. She never dismissed my concerns or accused me of overreacting. She never made me feel as though I wasn’t doing enough. Instead, she demonstrated an innate understanding of what it means to parent a neurodivergent child, despite not having firsthand experience herself. I vividly remember her first interaction with my son. She made an extraordinary effort to connect with him, to truly see his strengths and challenges, and to build a meaningful relationship. She worked collaboratively with me to adapt her approach to align with what I believed in as both an educator and a parent who had spent countless hours researching and understanding my child’s needs. I cannot thank Charlotte enough for making us feel valued, respected, and supported every step of the way. She ensured that our son had the tools he needed to thrive and kept his motivation alive through her genuine connection and expertise. Her dedication, compassion, knowledge, and willingness to go the extra mile for families like ours are nothing short of extraordinary.",
          author: "BK-educator and a mom"
        },
        {
          text: "We’ve been working with Charlotte for more than 3 years. She is always kid-centered, responsible and professional. She set the OT plan tailored to my daughter’s needs as well as to challenge her a bit. My daughter has gained so much progress with her help. And we are very happy to have her.",
          author: "Sulei, father of 9-year-old daughter"
        },
        {
          text: "It has been an absolute pleasure working with Charlotte! My 3-year-old daughter has sensory processing disorder and Charlotte has not only been her therapist for over a year now but has also become our friend checking in on those rough days. Charlotte makes our sessions fun for both my daughter and myself. She provides explanations for why certain behaviors occur and then suggests solutions to help mitigate the behaviors. She puts her heart into caring for every one of her clients and always greets us with the biggest smile. I cannot express just how excited my daughter is to see her every week. We love you, Charlotte! Thank you for everything you do and more!",
          author: "Mandy"
        },
        {
          text: "Charlotte’s sessions are a perfect blend of fun and purpose. Her gamified learning activities make even the most challenging tasks engaging, allowing students to learn through play while practicing the practical skills they need to succeed at school. She patiently explores different strategies to help students develop occupational skills, always adapting her methods to suit their individual needs and preferences. It’s heartwarming to see how much the students enjoy working with Charlotte. They feel at ease in her presence, and her patience and kindness make each session something they genuinely look forward to. The progress they make under her guidance is evident—not only in their skills but also in their confidence and enthusiasm for learning. What sets Charlotte apart even further is her collaboration with educators. She generously shares practical strategies and insights that help teachers better support their students in the classroom. Her professionalism, deep understanding of student needs, and unwavering kindness have made her an invaluable part of our school community.",
          author: "Upper School Learning Support Team at International School"
        }
      ],
      currentIndex: 0,
      isEnglish: true,
      autoPlayInterval: null,
    };
  },
  methods: {
    prevTestimonial() {
      this.currentIndex = (this.currentIndex - 1 + this.testimonialsData.length) % this.testimonialsData.length;
      this.updateTestimonials();
      this.updateDots();
    },
    nextTestimonial() {
      this.currentIndex = (this.currentIndex + 1) % this.testimonialsData.length;
      this.updateTestimonials();
      this.updateDots();
    },
    startAutoPlay() {
      this.stopAutoPlay(); // 确保先清除之前的定时器
      this.autoPlayInterval = setInterval(() => {
        this.$refs.carousel.next();
        this.currentIndex = (this.currentIndex + 1) % this.testimonialsData.length;
        this.updateDots();
      }, 3000);
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    },
    showTestimonial(index) {
      this.currentIndex = index;
      this.$refs.carousel.goTo(index);
      this.updateDots();
    },
    updateTestimonials() {
      const testimonials = document.querySelectorAll('.testimonial');
      testimonials.forEach((testimonial, i) => {
        if (i === this.currentIndex) {
          testimonial.classList.add('active');
        } else {
          testimonial.classList.remove('active');
        }
      });
    },
    updateDots() {
      const testimonialDots = document.querySelectorAll('.testimonial-dot');
      testimonialDots.forEach((dot, i) => {
        if (i === this.currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    }
  },
  watch: {
    currentLang(newLang) {
      this.isEnglish = newLang === 'en';
    }
  },
  mounted() {
    this.startAutoPlay();

    const dotsContainer = document.querySelector('.testimonial-dots');
    dotsContainer.addEventListener('mouseenter', this.stopAutoPlay);
    dotsContainer.addEventListener('mouseleave', this.startAutoPlay);
  },
  beforeDestroy() {
    this.stopAutoPlay();
    const dotsContainer = document.querySelector('.testimonial-dots');
    if (dotsContainer) {
      dotsContainer.removeEventListener('mouseenter', this.stopAutoPlay);
      dotsContainer.removeEventListener('mouseleave', this.startAutoPlay);
    }
  }
};
</script>

<style scoped lang="less">
@mainBg: #f8f5f0;
@mainBg2: #f8f5f1;
@mainColor1: #de94a4;
@mainColor2: #eebac0;
@mainColor3: #A98578;
@mainFont: "MontserratMedium", sans-serif;
@mainFontSub: "MontserratLight", sans-serif;
@mainFontCn: 'Huangchan', sans-serif;

.testimonial-container {
  background-color: @mainBg2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1vw;
  gap: 3vw;

  .testimonial-title {
    width: 45vw;
    font-size: 2.5em;
    font-weight: 600;
    color: @mainColor3;
    text-align: center;
  }

  .testimonial-box {
    width: 50vw;
    position: relative;

    .carousel {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      width: 77%;
      height: 100%;
      padding-top: 1vw;

      .testimonial {
        font-size: 1vw;

        &.active {
          display: inline-block;
        }

        p {
          min-height: 6em;
          max-height: 6em;
          overflow: auto;
          margin-top: 3em;
          margin-bottom: 3em;
          font-size: 1.6vw;

          /* 自定义滚动条（仅支持 WebKit 内核浏览器和 Firefox） */
          &.scrollable {
            /* Firefox 支持 */
            scrollbar-width: thin;
            scrollbar-color: rgba(@mainColor3, 0.5) transparent;
          }

          /* WebKit 浏览器滚动条宽度 */
          &.scrollable::-webkit-scrollbar {
            width: 12px;
            height: 12px;
            /* 水平滚动条高度 */
          }

          /* WebKit 浏览器滚动条轨道 */
          &.scrollable::-webkit-scrollbar-track {
            background-color: transparent!important;
            border-radius: 1vw;
          }

          /* WebKit 浏览器滚动条滑块 */
          &.scrollable::-webkit-scrollbar-thumb {
            background: #666;
          border-radius: 1vw;
            border: 2px solid #f1f1f1;
          }

          /* WebKit 浏览器滚动条滑块悬停效果 */
          &.scrollable::-webkit-scrollbar-thumb:hover {
            background: #555;
          }

          /* WebKit 浏览器滚动条角落 */
          &.scrollable::-webkit-scrollbar-corner {
            background: transparent!important;

          }
        }
      }

      /* author */
      .author {
        font-size: 1.3em;
        font-weight: bold;
        text-align: right;
        color: @mainColor3;
        font-family: @mainFont;
        padding-right: 5vw;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .testimonial-title {
      position: static;
      font-size: 4vw;
      text-align: center;
      margin: 0;
      transform: none;
      margin-bottom: 3vw;
    }

    .testimonial-box {
      width: 75vw;

      p {
        font-size: 2.4vw !important;
        min-height: 4.8em !important;
        max-height: 4.8em !important;
        margin-top: 3.2em !important;
        margin-bottom: 3.5em !important;
      }

      .author {
        font-size: 2.3vw !important;
      }
    }

    .testimonial-dots {
      display: none!important;
    }
  }

  /* dots*/
  .testimonial-dots {
    display: flex;
    justify-content: center;
    gap: 0.9vw;
    margin-top: 3vw;

    .testimonial-dot {
      height: 1vw;
      width: 1vw;
      background-color: #9FBADD;
      border-radius: 50%;
      display: inline-block;
      cursor: pointer;

      &.active {
        background-color: @mainColor3;
      }
    }
  }

  .carousel-content {
    transition: transform 0.5s ease-in-out;
  }

  .left {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    background-color: rgba(255, 255, 255, 0.7);
    border: none;
    cursor: pointer;
    padding: 10px;
    border-radius: 50%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .right {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    background-color: rgba(255, 255, 255, 0.7);
    border: none;
    cursor: pointer;
    padding: 10px;
    border-radius: 50%;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
}
</style>
